import { SUPPORTED_GOOGLE_FONTS } from '~/utilities/fonts';

const getLoadedGoogleFonts = () => {
  const linkElements = document.querySelectorAll<HTMLLinkElement>(
    'link[rel="stylesheet"][href^="https://fonts.googleapis.com/css"]',
  );

  if (linkElements.length === 0) {
    return [];
  }

  return Array.from(linkElements)
    .map(({ href }) => {
      const url = new URL(href);
      const fontFamilies = url.searchParams.get('family');
      return fontFamilies?.split('|');
    })
    .flat()
    .filter(Boolean);
};

export const injectGoogleFonts = (fontFamilies: string[] | string): void => {
  const fonts = typeof fontFamilies === 'string' ? [fontFamilies] : fontFamilies;
  const validFonts = fonts.filter((font) => SUPPORTED_GOOGLE_FONTS.includes(font));
  if (validFonts.length === 0) {
    return;
  }

  const loadedFonts = getLoadedGoogleFonts();
  const encodedFonts = validFonts
    .filter((fontName) => !loadedFonts.includes(fontName))
    .map((fontName) => encodeURIComponent(fontName).replace('%20', '+'));

  if (encodedFonts.length === 0) {
    return;
  }

  const link = document.createElement('link');
  link.href = `https://fonts.googleapis.com/css?family=${encodedFonts.join('|')}`;
  link.rel = 'stylesheet';

  document.head.appendChild(link);
};
